<template>
    <div class="row panel-body">
        <input type="hidden" name="_token" :value="csrfToken"/>

        <quiz-english-master-correction-question
                v-for="(question, idx) in questions"
                v-on:forceUpdate="forceUpdate()"
                ref="questions"
                :idx="idx"
                :key="question.qid"
                :iqid="question.qid"
                :itype="question.type"
                :level="parseInt(question.level)"
                :isuggestedAnswerOid="question.suggestedAnswerOid"
                :iquestionText="question.text.XX_en"
                :ioptions="question.options"
                :ipictureUrl="question.pictureUrl"
                :image-upload-route="imageUploadRoute"
                :question-types="JSON.parse(questionTypesJson)"
        ></quiz-english-master-correction-question>

        <div class="row">
            <div class=" alert alert-warning" style="margin: 15px; padding: 15px 30px;">
                <h3>Could any of your changes affect translations to other languages?</h3>
                <p>If you <b>only</b> changed the correctness or picture or type of a question, select <b>no</b>!</p>
                <br>
                <input v-model="affectsTranslations"
                       type="radio"
                       name="affects_other_languages"
                       value="1"
                       id="affectsYes">
                <label for="affectsYes">Yes</label><br/>
                <input v-model="affectsTranslations"
                       type="radio"
                       name="affects_other_languages"
                       value="0"
                       id="affectsNo">
                <label for="affectsNo">No</label>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 text-right">
                <submit-button :disabled="!allDataIsValid" title="Submit"></submit-button>
            </div>
        </div>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        props: {
            'questionsJson': String,
            'questionTypesJson': String,
            'imageUploadRoute': String,
        },

        data: function() {
            return {
                questions: [],
                csrfToken: window.csrfToken,
                updateTrigger: false,
                affectsTranslations: null,
            };
        },

        computed: {
            allDataIsValid: function() {
                if (this.updateTrigger) {
                    for (let index in this.$refs.questions) {
                        if (!this.$refs.questions[index].validate()) {
                            return false;
                        }
                    }
                    return this.affectsTranslations !== null;
                }
            },
        },

        mounted() {
            let questions = JSON.parse(this.questionsJson);
            let tmpQuestionsArray = [];
            for (let idx in questions) {
                if (!('suggestedAnswerOid' in questions[idx])) {
                    questions[idx].suggestedAnswerOid = null;
                }
                tmpQuestionsArray.push(questions[idx]);
            }
            // don't push to this.questions inside of the loop, because it triggers re-rendering in every iteration.
            this.questions = tmpQuestionsArray;

            this.updateTrigger = true;
            this.forceUpdate();
        },

        methods: {
            forceUpdate: function() {
                this.updateTrigger = false;
                this.$forceUpdate();
                this.updateTrigger = true;
            },
        },
    };
</script>
